<div class="w-full h-full mt-2">
    @if (mostrarVistaPrevia) {
        <div class="flex flex-row items-center justify-between border-b" >

            @if(tipoTarea != tareaTipoGestion){
                <div class="w-full flex justify-end">
                
                    <button mat-raised-button class="w-32 rounded-r-xl font-bold" (click)="aceptarDocumento(documentData)">
                        Aprobar
                    </button>
                    <button mat-raised-button class="w-32 rounded-l-xl font-bold" (click)="rechazarDocumento(documentData)">
                        Rechazar
                    </button>
                </div>
            }
            

            <button mat-flat-button [color]="'seccondary'" (click)="closeDrawer1()">
                <mat-icon
                    class=""
                    [svgIcon]="'heroicons_outline:x-mark'"
                ></mat-icon>
            </button>

    
        </div>
        @if (renderObject) {
            <div class="w-full h-full py-2"   >
                @if (documentUrl) {
                    <object 
                        class="w-full h-full" 
                        [attr.data]="documentUrl" 
                        [attr.type]="documentType">
                    </object>
                }
        </div>
        }
        
    }@else{
        <div class="flex flex-row items-center justify-end border-b" >
            <button mat-flat-button [color]="'seccondary'" (click)="closeDrawer1()">
                <mat-icon
                    class=""
                    [svgIcon]="'heroicons_outline:x-mark'"
                ></mat-icon>
            </button>
        </div>

        <div class="w-full h-full py-2 flex flex-col items-center justify-center" >
            <div class="w-full flex flex-col items-center justify-center p-6">
                <h2 class="text-3xl md:text-5xl font-bold text-center text-gray-800">
                  Vista previa no disponible
                </h2>
                <p class="text-lg md:text-xl text-gray-500 text-center mt-4">
                  No se puede visualizar este tipo de archivo, pero puedes descargarlo.
                </p>
                <button [matTooltip]="'Descargar documento'" (click)="downloadFile()">
                    <mat-icon class="icon-size-20">cloud_download</mat-icon>
                </button>
            </div>
        </div>
          
    }


 
</div>

<!-- <div *ngIf="pdfUrl; else loading">
    <object [data]="pdfUrl" type="application/pdf" width="100%" height="600px">
      <p>Tu navegador no soporta PDFs. <a [href]="pdfUrl" download>Descárgalo aquí</a>.</p>
    </object>
  </div>
  <ng-template #loading>
    <p>Cargando PDF...</p>
  </ng-template> -->